import React, { FunctionComponent } from 'react';
import { SvgIcon } from '@mui/material';

export const ResetViewIcon: FunctionComponent = () => (
  <SvgIcon viewBox="0 0 12 12">
    <g transform="translate(23.119806,-142.51356)">
      <path
        d="
          m -20.561473,149.86356
          h -1.058333
          v 2.11667
          c 0,0.58473 0.473604,1.05833 1.058333,1.05833
          h 2.116667
          v -1.05833
          h -2.116667
          z
          m 0,-5.29167
          h 2.116667
          v -1.05833
          h -2.116667
          c -0.584729,0 -1.058333,0.4736 -1.058333,1.05833
          v 2.11667
          h 1.058333
          z
          m 7.408334,-1.05833
          h -2.116667
          v 1.05833
          h 2.116667
          v 2.11667
          h 1.058333
          v -2.11667
          c 0,-0.58473 -0.473604,-1.05833 -1.058333,-1.05833
          z
          m 0,8.46667
          h -2.116667
          v 1.05833
          h 2.116667
          c 0.584729,0 1.058333,-0.4736 1.058333,-1.05833
          v -2.11667
          h -1.058333
          z"
      />
      <path
        transform="matrix(0.59225615,0,0,0.59225615,-6.95267,60.352736)"
        d="
          m -16.764789,143.17527
          c -2.923646,0 -5.291667,2.36802 -5.291667,5.29167 0,2.92365 2.368021,5.29167 5.291667,5.29167 2.923646,0 5.291667,-2.36802 5.291667,-5.29167 0,-2.92365 -2.368021,-5.29167 -5.291667,-5.29167
          z
          m 2.645833,7.18873 -0.748771,0.74877 -1.897062,-1.89706 -1.897063,1.89706 -0.74877,-0.74877 1.897062,-1.89706 -1.897062,-1.89706 0.74877,-0.74877 1.897063,1.89706 1.897062,-1.89706 0.748771,0.74877 -1.897062,1.89706
          z"
      />
    </g>
  </SvgIcon>
);
